import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import TermSheetScheduleRowCreateModalUI from './TermSheetScheduleRowCreateModalUI.js'

class TermSheetScheduleRowCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      particular: '',
      particularError: null,
      termsAndConditions: '',
      termsAndConditionsError: null,
    }
  }

  render() {
    return (
      <TermSheetScheduleRowCreateModalUI
        context={this.props.context}
        createMode={this.props.createMode}
        onCancelClick={this.onCancelClick}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        particular={this.state.particular}
        onParticularChange={(event) => this.setState({ particular: event.target.value })}
        particularError={this.state.particularError}
        setParticularError={(error) => this.setState({ particularError: error })}
        termsAndConditions={this.state.termsAndConditions}
        onTermsAndConditionsChange={(event) => this.setState({ termsAndConditions: event.target.value })}
        termsAndConditionsError={this.state.termsAndConditionsError}
        setTermsAndConditionsError={(error) => this.setState({ termsAndConditionsError: error })}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.createMode && !prevProps.createMode) {
      this.setState({
        particular: '',
        termsAndConditions: '',
        particularError: null,
        termsAndConditionsError: null,
        successMsg: null,
        errorList: null,
      })
    }
  }

  onCancelClick = () => {
    this.setState({
      particular: '',
      termsAndConditions: '',
      particularError: null,
      termsAndConditionsError: null,
      successMsg: null,
      errorList: null,
    })
    this.props.onCreateRowCancel()
  }

  onSubmit = () => {
    if (this.state.submitted) return
    if (!this.state.particular) {
      this.setState({ particularError: 'Required' })
      return
    }
    if (!this.state.termsAndConditions) {
      this.setState({ termsAndConditionsError: 'Required' })
      return
    }
    this.setState({ successMsg: null, errorList: [], submitted: true })
    RestApiUtils.post(
      this.props.context,
      this.props.loan.loanId === 'master'
        ? '/api/su/master/termSheet/scheduleRows'
        : `/api/su/loans/${this.props.loan.loanId}/termSheet/scheduleRows`,
      this.onSubmitCallback,
      {
        particular: this.state.particular,
        termsAndConditions: this.state.termsAndConditions,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })
    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    })
    if (!errorList || errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default TermSheetScheduleRowCreateModalSF
